import Button from '@/components/Button';
import Icon from '@/components/Icon';
import { X as CloseIcon } from 'react-feather';
import classes from './virtualAppointments.module.css';

export const CancelDialog = props => {
  const { canCelhandle, canCelSubmit, id } = props;

  return (
    <div className={classes.canceldialog}>
      <div className={classes.canceldialogcontent}>
        <i
          className={classes.close}
          onClick={canCelhandle}
        >
          <Icon src={CloseIcon} />
        </i>
        <div className={classes.coninfo}>
          <p className={classes.dialogtitle}>Are you sure you want to cancel this appointment?</p>
          <Button
            className={classes.yes}
            onClick={() => canCelSubmit(id)}
          >
            Yes
          </Button>
          <Button
            className={classes.no}
            onClick={canCelhandle}
          >
            No
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CancelDialog;
